import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { merge } from 'lodash-es';
import { ApiResponse } from "../../../classes/api-response";
import { CompaniesService } from "../../../services/companies.service";
import { SnackService } from "../../../services/snack.service";
import { Company } from "../../../model/company";
import { PublicService } from "../../../services/public.service";
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'aw-company-form',
  templateUrl: './company-form.component.html',
  styleUrls: ['./company-form.component.scss']
})
export class CompanyFormComponent implements OnInit {

  companyForm: UntypedFormGroup;
  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  saving = false;
  generalError?: ApiResponse;
  @Input() isRegistrationRequest = false;
  recaptchaKey = environment.captchaKey;

  constructor(
    private companyService: CompaniesService,
    private publicService: PublicService,
    private snackService: SnackService,
  ) {


    this.companyForm = new UntypedFormGroup(
      {
        companyName: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        companyEmail: new UntypedFormControl(
          '',
          [
            Validators.pattern("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?"),
            Validators.required
          ]
        ),
        companyAddress: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        contact1email: new UntypedFormControl(
          undefined,
          [
            Validators.pattern("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?")
          ]
        ),
        contact2email: new UntypedFormControl(
          undefined,
          [
            Validators.pattern("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?")
          ]
        ),
        contact1phone: new UntypedFormControl(
          '',
          [
            Validators.pattern('[- +()0-9]+')
          ]
        ),
        contact2phone: new UntypedFormControl(
          '',
          [
            Validators.pattern('[- +()0-9]+')
          ]
        ),
        contact1role: new UntypedFormControl(
          '',
          []
        ),
        contact2role: new UntypedFormControl(
          '',
          []
        ),
      }
    );


  }

  _company = new Company();

  @Input() set company(value: Company) {
    this._company = merge(new Company(), value);
    this.companyForm.patchValue(this._company);
  }

  ngOnInit(): void {
    if (this.isRegistrationRequest) {
      this.companyForm.addControl('recaptchaReactive', new UntypedFormControl(null, Validators.required));
    }
  }

  saveCompany(): void {

    this.saving = true;

    const newCompany = merge(new Company(), this._company, this.companyForm.value);

    this.generalError = undefined;

    if (this._company.id) {
      delete newCompany.customers;
      delete newCompany.contracts;
      delete newCompany.testbeds;
      this.companyService.updateCompany(newCompany)
        .subscribe(
          () => {
            this.saving = false;
            this.company = newCompany;
            this.snackService.success('Company updated!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    } else {

      this.companyService.createCompany(newCompany)
        .subscribe(
          () => {
            this.saving = false;
            this.company = newCompany;
            this.snackService.success('Company created!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    }

  }

  submitCompanyRequest(): void {

    this.saving = true;
    const newCompany = merge(new Company(), this._company, this.companyForm.value);
    this.generalError = undefined;
    this.publicService.submitCompanyRequest(newCompany)
      .subscribe(
        () => {
          this.saving = false;
          this.snackService.success(`Company request for "${newCompany.companyName}" submitted!`);
          this.saved.emit();
        },
        error => {
          this.saving = false;
          this.snackService.error(error.message);
          this.generalError = error;
        },
        () => {
          this.saving = false;
        });
  }
}
